import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalAlertImg from '../../../../../../common/assets/images/merchants/modal-attention.svg';
import { showErrorToast } from '../../../../../../common/global/helpers';
import Button from '../../../../../../common/widgets/Button';
import Dialog from '../../../../../../common/widgets/Dialog';
import { resources } from '../../../../resources/resources';
import { productsService } from '../../../../services/products';

interface CancelProductDeactivationDialogProps {
  closeDialog: () => void;
  productId: number;
  onCancelDeactivation: (productId: number) => void;
}

export const CancelProductDeactivationDialog = (
  props: CancelProductDeactivationDialogProps,
) => {
  const { closeDialog, productId, onCancelDeactivation } = props;
  const { t: translate } = useTranslation();
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);

  const onSaveClick = async () => {
    setIsButtonLoading(true);
    const resp = await productsService.cancelProductDeactivation(productId);
    setIsButtonLoading(false);
    if (resp.hasErrors) {
      showErrorToast(translate(resources.errors.generic));
    } else {
      onCancelDeactivation(productId);
    }
  };

  return (
    <Dialog closeDialog={closeDialog} showCloseIcon className="dialog-m">
      <div className="dialog-content">
        <div className="dialog-image m-dialog-img">
          <img
            src={ModalAlertImg}
            alt={translate(
              resources.products.list.cancelProductDeactivation.title,
            )}
          />
        </div>
        <div className="dialog-title">
          {translate(resources.products.list.cancelProductDeactivation.title)}
        </div>
        <div className="dialog-text centered mb-20">
          {translate(resources.products.list.cancelProductDeactivation.info)}
        </div>
      </div>

      <div className="dialog-actions horizontal">
        <Button
          className="btn btn-outline"
          onClick={closeDialog}
          disabled={isButtonLoading}
        >
          <span className="btn-text">{translate(resources.abort)}</span>
        </Button>
        <Button
          className="btn btn-solid"
          onClick={onSaveClick}
          loading={isButtonLoading}
        >
          <span className="btn-text">{translate(resources.confirm)}</span>
        </Button>
      </div>
    </Dialog>
  );
};
